export default __webpack_public_path__ + "static/present-606cc6277c4baab5abd1823d88d9f992.webm";